module.exports = __webpack_public_path__ + "img/cloud-arrow-up.e7143146.svg";